import { render, staticRenderFns } from "./ContractPage.vue?vue&type=template&id=1cf4a228&scoped=true&"
import script from "./ContractPage.vue?vue&type=script&lang=js&"
export * from "./ContractPage.vue?vue&type=script&lang=js&"
import style0 from "./ContractPage.vue?vue&type=style&index=0&id=1cf4a228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf4a228",
  null
  
)

export default component.exports